export const validateCustomIdToEmpty = array => {
	return array.map(item => (typeof item.id !== 'number' ? { ...item, id: '' } : item))
}
